import { Tag } from 'antd';
import dayjs from 'dayjs';

/**
 * SHAR-1201 — "Account deleted on 08/10/2026" beside a customer whose account
 * was deleted (DELETE /user/me). The bookings, holds and contact details stay;
 * this says why the email reads "deleted+…". Nothing for a live account.
 */
export function AccountDeletedTag({ at }: { at?: string | null }) {
  if (!at) return null;
  return (
    <Tag color="default" style={{ marginInlineEnd: 0 }}>
      Account deleted on {dayjs(at).format('DD/MM/YYYY')}
    </Tag>
  );
}
